import React, { useEffect, useState } from "react";
import './loapoiframe.css'
import { showToast } from './toastUtils';
import FullscreenLoader from './FullscreenLoader';
import { queuedApiFetch, apiFetch } from './api';

// Default Dummy Data for LOA/PO Table
const DEFAULT_DUMMY_LOA_PO_DATA = [
  {
    P_grp_desc: "Main Construction",
    P_grp_item_desc: "Main Contract Sum",
    vendor_name: "Woh Hup (Private) Limited",
    contract_no: "NUS-CON-2024-001",
    rateby_lumpsum: "0.00",
    apv_tender_ref_no: "NUS/TDR/2024/001",
    po_no: "PO-2024-8891",
    interim_po_amount_wo_gst: 15450000.00,
    final_po_amount_wo_gst: 15450000.00,
    totalValue: 15450000.00,
    finalValue: 0
  },
  {
    P_grp_desc: "Consultancy Services",
    P_grp_item_desc: "Consultant Fees (Arch)",
    vendor_name: "DP Architects Pte Ltd",
    contract_no: "NUS-ARC-2024-002",
    rateby_lumpsum: "4.50",
    apv_tender_ref_no: "NUS/TDR/2024/002",
    po_no: "PO-2024-8892",
    interim_po_amount_wo_gst: 695250.00,
    final_po_amount_wo_gst: 695250.00,
    totalValue: 695250.00,
    finalValue: 0
  },
  {
    P_grp_desc: "Consultancy Services",
    P_grp_item_desc: "Consultant Fees (C&S)",
    vendor_name: "KTP Consultants Pte Ltd",
    contract_no: "NUS-CNS-2024-003",
    rateby_lumpsum: "3.20",
    apv_tender_ref_no: "NUS/TDR/2024/003",
    po_no: "PO-2024-8893",
    interim_po_amount_wo_gst: 494400.00,
    final_po_amount_wo_gst: 494400.00,
    totalValue: 494400.00,
    finalValue: 0
  },
  {
    P_grp_desc: "Consultancy Services",
    P_grp_item_desc: "Consultant Fees (M&E)",
    vendor_name: "Beca Carter Hollings & Ferner",
    contract_no: "NUS-MNE-2024-004",
    rateby_lumpsum: "3.50",
    apv_tender_ref_no: "NUS/TDR/2024/004",
    po_no: "PO-2024-8894",
    interim_po_amount_wo_gst: 540750.00,
    final_po_amount_wo_gst: 540750.00,
    totalValue: 540750.00,
    finalValue: 0
  },
  {
    P_grp_desc: "Consultancy Services",
    P_grp_item_desc: "QS Fees",
    vendor_name: "Rider Levett Bucknall",
    contract_no: "NUS-QS-2024-005",
    rateby_lumpsum: "1.20",
    apv_tender_ref_no: "NUS/TDR/2024/005",
    po_no: "PO-2024-8895",
    interim_po_amount_wo_gst: 185400.00,
    final_po_amount_wo_gst: 185400.00,
    totalValue: 185400.00,
    finalValue: 0
  },
  {
    P_grp_desc: "Contingency",
    P_grp_item_desc: "Project Contingency",
    vendor_name: "NUS In-House",
    contract_no: "NUS-CTG-2024-006",
    rateby_lumpsum: "0.00",
    apv_tender_ref_no: "NUS/TDR/2024/006",
    po_no: "PO-2024-8896",
    interim_po_amount_wo_gst: 800000.00,
    final_po_amount_wo_gst: 800000.00,
    totalValue: 800000.00,
    finalValue: 0
  }
];

function Loapoiframe() {
  const [dataLoading, setDataLoading] = useState(false);
  const [LOAdataLoading, setLOADataLoading] = useState(false);
  const [itemList, setItemList] = useState(DEFAULT_DUMMY_LOA_PO_DATA);
  const getProjectDetails = localStorage.getItem('projectDetails');
  const selectedProjectDetail = JSON.parse(getProjectDetails);
  const projectid = selectedProjectDetail.projectNumber;
  // const getUserDetails = localStorage.getItem('userDetails');
  // const userDetails = getUserDetails ? JSON.parse(getUserDetails) : '';
  // const getUserAccess = userDetails ? userDetails.access_level : '';  

  //const getUserAccess = 'project_user';  
    const getUserDetails = localStorage.getItem('userDetails');
    const userDetails = getUserDetails ? JSON.parse(getUserDetails): '';
    const userId = userDetails ? userDetails.id : '';
    const userName = userDetails ? userDetails.name : '';
    
    const getUserAccess = userDetails ? userDetails.access_level : '';
    const [userCompany, setUserCompany] = useState();
    const getUserCompanyDetails =userCompany;
    const getUserEmail = localStorage.getItem('userEmail');
    const [userPermission, setUserPermission] = useState();
    const [userRoleManual, setUserRolesManual] = useState();
    const [loading, setLoading] = useState(true);
    const [editValues, setEditValues] = useState({});
    const [proj_access_level, setProjAccessLevel] = useState(false);


    const fetchUserCompany = async () => {
      const requestOptions = {
        method: 'GET',
        //headers: new Headers({ 'ngrok-skip-browser-warning': '69420' })
      };
       try {
        const response = await queuedApiFetch(`/user/getuserprofile?emailid=${getUserEmail}`, requestOptions);
        const data = await response;
    
        if (data.apistatus.Status_Code === 200 && data.apistatus.Status_Description.toLowerCase() === 'success') {
          setUserCompany(data.data.company_name);
          setUserPermission(data.data.access_level);     
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        //setLoading(false); // End loading
      }
    }
  
    const fetchUserRole = async () => {
      if (!userId || !projectid) {
        return;
      }
      const requestOptions = {
        method: 'GET',
        //headers: new Headers({ 'ngrok-skip-browser-warning': '69420' })
      };
       try {
        const response = await queuedApiFetch(`/project/get_project_role?userid=${userId}&projectid=${projectid}`, requestOptions);
        const data = await response;
    
        if (data.apistatus.Status_Code === 200 && data.apistatus.Status_Description.toLowerCase() === 'success') {
        // console.log(data.data); 
        setUserRolesManual(data.data);
        setProjAccessLevel(data.access_level);
        //setUserRolesManual('Admin');
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        //setLoading(false); // End loading
      }
    }


    const fetchData = async () => {
      try {
          await fetchUserCompany();
          await fetchUserRole();
          
      } catch (error) {
          console.error("Error fetching data:", error);
      }
  };

  useEffect(() => {
    fetchData();
    fetchEditWBSData();
  }, []);

  const fetchEditWBSData = async () => {
    setDataLoading(true);
    const requestOptions = {
      method: "GET",
      //headers: new Headers({ 'ngrok-skip-browser-warning': '69420' }),
    };

    try {
      const response = await queuedApiFetch(`/funding/getwbsgroup?projectid=${projectid}`,
        requestOptions
      );
      const data = await response;
      if (data.apistatus.Status_Code === 200 && data.apistatus.Status_Description.toLowerCase() === 'success') {
        const filteredData = data.data.filter(item => !(item.P_grp_id === 1 && item.P_grp_item_id === 3)) 
        .map(({ ID, Project_id, P_grp_desc, P_grp_item_desc, P_grp_wbs_value }) => ({
          ID,
          Project_id,
          P_grp_desc,
          P_grp_item_desc,
          P_grp_wbs_value
        }));
        const groupedData = filteredData.reduce((acc, item) => {
          const groupKey = `${item.P_grp_desc}||${item.P_grp_item_desc}`;

          if (!acc[groupKey]) {
            acc[groupKey] = { totalValue: 0, items: [] };
          }

          acc[groupKey].totalValue += item.P_grp_wbs_value || 0;
          acc[groupKey].items.push(item);

          return acc;
        }, {});

        const finalData = Object.keys(groupedData).map(key => {
          const [P_grp_desc, P_grp_item_desc] = key.split('||');

          return {
            P_grp_desc,
            P_grp_item_desc,
            totalValue: groupedData[key].totalValue,
            items: groupedData[key].items,
            finalValue: 0
          };
        });

        const uniqueData = finalData.filter(
          (item, index, self) =>
            index === self.findIndex((t) =>
              t.P_grp_desc === item.P_grp_desc && t.P_grp_item_desc === item.P_grp_item_desc
            )
        );

        const getloaData = await getLOAData();
        
        // console.log('getloaData', getloaData);

        const matchedData = uniqueData.map(uData => {
          if (!uData.P_grp_item_desc) return uData;
          const itemWords = uData.P_grp_item_desc.toLowerCase();
          const match = getloaData.find(gData =>
            gData.description && gData.description.toLowerCase() === itemWords)
          // return match ? { ...uData, ...match } : uData;
          return match ? { ...uData, ...match } : uData;
        });
        //setItemList(matchedData);

         if (matchedData && matchedData.length > 0) {
          setItemList(matchedData);
        } else {
          setItemList(DEFAULT_DUMMY_LOA_PO_DATA);
        }

        // console.log('matchedData...', matchedData);
      }
    } catch (error) {
      console.warn("Using dummy LOA/PO data as fallback:", error);
      setItemList(DEFAULT_DUMMY_LOA_PO_DATA);
      //console.error("Error fetching data:", error);
    } finally {
      setDataLoading(false);
      setLoading(false); 
    }
  };

  const getLOAData = async () => {
    setLOADataLoading(true);
    const requestOptions = {
      method: "GET",
      //headers: new Headers({ 'ngrok-skip-browser-warning': '69420' }),
    };
    try {
      const response = await queuedApiFetch(`/funding/get_loa_po_list?projectid=${projectid}`,
        requestOptions
      );
      const data = await response;
      if (data.apistatus.Status_Code === 200 && data.apistatus.Status_Description.toLowerCase() === 'success') {
        return data.data;
      } else {
        return [];
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLOADataLoading(false);
    }
  };

  const formatNumber = (value) => {
    const num = parseFloat(value);
    if (isNaN(num)) return '';
    return new Intl.NumberFormat('en-IN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(num);
  };
  
  

  // const handleInputChange = (e, itemDes, fieldName) => {
  //   const updatedValue = e.target.value;
  //   const updatedList = itemList.map(item => {
  //     if (item.P_grp_item_desc === itemDes) {
  //       const updatedItem = { ...item, [fieldName]: updatedValue };
  //       // Recalculate finalValue only if the number input is changed
  //       // if (fieldName === "rateby_lumpsum") {
  //       //   updatedItem.finalValue = updatedValue * item.totalValue;
  //       // }
  //       return updatedItem;
  //     }
  //     return item;
  //   });
  //   setItemList(updatedList);
  // };

  const handleInputChange = (e, itemDes, fieldName) => {
    // const inputValue = e.target.value.replace(/,/g, ''); // remove commas
    // const updatedValue = isNaN(parseFloat(inputValue)) ? '' : parseFloat(inputValue);

    let updatedValue;
    if (fieldName === "apv_tender_ref_no" || fieldName === "po_no" || fieldName === "vendor_name" || fieldName === "contract_no") {
      updatedValue = e.target.value;
    } else {
      const inputValue = e.target.value.replace(/,/g, '');
      updatedValue = isNaN(parseFloat(inputValue)) ? '' : parseFloat(inputValue);
    }
  
    const updatedList = itemList.map(item => {
      if (item.P_grp_item_desc === itemDes) {
        // const updatedItem = { ...item, [fieldName]: updatedValue };
        // return updatedItem;

        return { ...item, [fieldName]: updatedValue };
      }
      return item;
    });
  
    setItemList(updatedList);
  };
  


  const saveLoaPO = async () => {

    const formattedData = itemList.map(({ po_no, apv_tender_ref_no, apvTenderRefNo, P_grp_item_desc, vendor_name, contract_no, rateby_lumpsum, interim_po_amount_wo_gst, original_budget, finalValue, totalValue, final_po_amount_wo_gst }) => ({
      project_id : projectid,
      po_no: po_no || '',
      apv_tender_ref_no: apv_tender_ref_no || apvTenderRefNo || '',
      description: P_grp_item_desc || '',
      vendor_name: vendor_name || '',
      contract_no: contract_no || '',
      // rateby_lumpsum : (!P_grp_item_desc?.trim().toLowerCase().includes("consultant fees") && !P_grp_item_desc?.trim().toLowerCase().includes("qs fees")) ?  original_budget ? original_budget : '' : rateOrLumpSum || '',
      // interim_po_amount_wo_gst: P_grp_item_desc?.trim().toLowerCase().includes("consultant fees") || P_grp_item_desc?.trim().toLowerCase().includes("qs fees") ? finalValue > 0 ? finalValue : totalValue : interimPOAmount || 0,
      // final_po_amount_wo_gst : finalPOAmount || 0

      rateby_lumpsum: (!P_grp_item_desc?.trim().toLowerCase().includes("consultant fees") &&
        !P_grp_item_desc?.trim().toLowerCase().includes("qs fees"))
        ? (original_budget ? parseFloat(original_budget).toFixed(2) : 0.00)
        : (rateby_lumpsum ? parseFloat(rateby_lumpsum).toFixed(2) : 0.00),

      interim_po_amount_wo_gst: (P_grp_item_desc?.trim().toLowerCase().includes("consultant fees") ||
        P_grp_item_desc?.trim().toLowerCase().includes("qs fees"))
        ? (finalValue > 0 ? parseFloat(finalValue).toFixed(2) :  (rateby_lumpsum>0)? parseFloat(totalValue).toFixed(2):parseFloat(totalValue).toFixed(2))
        : (rateby_lumpsum>0)? parseFloat(interim_po_amount_wo_gst).toFixed(2):parseFloat(interim_po_amount_wo_gst).toFixed(2),

      final_po_amount_wo_gst: parseFloat(final_po_amount_wo_gst || 0).toFixed(2),
    }));

    // console.log('formattedData......', formattedData);

    const requestOptions = {
      method: 'POST',
      // headers: {
      //   'Content-Type': 'application/json',
      //   'ngrok-skip-browser-warning': '69420',
      // },
      body: JSON.stringify(formattedData),
    };
    try {
      const response = await queuedApiFetch('/funding/insert_loa_po', requestOptions);
      const result = await response;
      if (result.apistatus.Status_Code === 200 && result.apistatus.Status_Description.toLowerCase() === 'success') {
        showToast.success('Data saved successfully');
        // fetchEditWBSData();
      } else {
        showToast.error(result.apistatus.Status_Description || 'Please try again later');
      }
    } catch (error) {
      console.error('Error saving data:', error);
    } finally {
      // setFinalSubmitLoading(false);
    }
  }

  //For Permission Handling
  const isDisabled = false;
  // const isDisabled = (
  //   getUserCompanyDetails === 'NUS' && (
  //     userPermission === 'account_admin' ||
  //     (userPermission === 'project_admin' && (
  //       userRoleManual === '' ||
  //       userRoleManual === 'Project Manager (PM)' ||
  //       userRoleManual === 'Admin'
  //     ))
  //   )
  // );
  
  // const access_sts = (
  //     expectedCompany,
  //     // accountAdminPermissions = [],
  //     projectAdminRoles = []
  //   ) => {
  //     const sts=(
  //       (getUserCompanyDetails === expectedCompany && (userPermission === 'account_admin' || userPermission === 'project_admin')  && userRoleManual?.length===0) ||        
  //       projectAdminRoles.some(item=>userRoleManual?.includes?.(item))
  //     );
  //     return sts;
  //   };

  const access_sts = (
      expectedCompany,
      // accountAdminPermissions = [],
      projectAdminRoles = []
    ) => {
      const sts=(
        // (getUserCompanyDetails === expectedCompany && proj_access_level === true ) ||        
        projectAdminRoles.some(item=>userRoleManual?.includes?.(item))
      );
      return sts;
    };

  return (
    <div className="bodywrap">
      {loading && <FullscreenLoader />} 
      <div className="loapo-container">
        <div className="loapo-header">
          <div className="loapo-header-left">
            <h2 className="loapo-title">LOA / PO Tracking Table</h2>
            <span className="loapo-badge">Project: {projectid || "PRJ-001"}</span>
          </div>
          <div className="loapo-header-right">
            <button
              id="submit"
              className="btn-save-changes"
              disabled={false}
              onClick={() => saveLoaPO()}
            >
              Save Changes
            </button>
          </div>
        </div>

        <div className="loapo-table-card">
          <div className="loapo-table-responsive">
            <table className="loapo-table">
              <thead>
                <tr>
                  <th style={{ width: "200px", textAlign: "left" }}>Description</th>
                  <th style={{ width: "180px", textAlign: "left" }}>Vendor Name</th>
                  <th style={{ width: "125px", textAlign: "left" }}>LOA Ref</th>
                  <th style={{ width: "105px", textAlign: "center" }}>Rate (%)/Lump Sum</th>
                  <th style={{ width: "155px", textAlign: "center" }}>APV Tender Ref No.</th>
                  <th style={{ width: "135px", textAlign: "center" }}>PO No.</th>
                  <th style={{ width: "180px", textAlign: "right" }}>
                    <div>Interim PO Amount</div>
                    <div style={{ fontSize: "11px", fontWeight: "600", opacity: 0.85, textTransform: "none", marginTop: "2px" }}>
                      w/o GST ($)
                    </div>
                  </th>
                  <th style={{ width: "210px", textAlign: "right", paddingRight: "16px" }}>
                    <div>Final PO Amount</div>
                    <div style={{ fontSize: "11px", fontWeight: "600", opacity: 0.85, textTransform: "none", marginTop: "2px" }}>
                      w/o GST ($)
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                {itemList && itemList.length > 0 ? (
                  itemList
                    .filter(item => item.P_grp_item_desc && item.P_grp_item_desc !== "null" && item.P_grp_item_desc.trim() !== "" && item.P_grp_desc !== "GST Adjustment")
                    .map((item, index) => (
                      <tr key={index} className="loapo-row">
                        <td className="cell-desc font-semibold">{item.P_grp_item_desc}</td>
                        <td className="cell-vendor">{item.vendor_name || "-"}</td>
                        <td className="cell-contract font-mono">{item.contract_no || "-"}</td>
                        <td className="cell-rate text-center">
                          {item.P_grp_item_desc?.trim().toLowerCase().includes("consultant fees") ||
                            item.P_grp_item_desc?.trim().toLowerCase().includes("qs fees") ? (
                            <input
                              className="loapo-input text-center"
                              style={{ width: "70px", margin: "0 auto" }}
                              defaultValue={item.rateby_lumpsum}
                              type="text"
                              onInput={(e) => {
                                const value = e.target.value;
                                if (!/^\d*$/.test(value)) {
                                  e.target.value = value.replace(/\D/g, "");
                                } else {
                                  handleInputChange(e, item.P_grp_item_desc, "rateby_lumpsum");
                                }
                              }}
                            />
                          ) : (item.rateby_lumpsum === "" || item.rateby_lumpsum === "0.00" || item.rateby_lumpsum == null) ? (
                            <span className="badge-lumpsum">Lump Sum</span>
                          ) : (
                            item.rateby_lumpsum
                          )}
                        </td>

                        {/* Kolom Baru: APV Tender Ref No. */}
                        <td className="cell-input text-center">
                          <input
                            type="text"
                            placeholder="Tender Ref No."
                            title={item.apv_tender_ref_no ?? item.apvTenderRefNo ?? ""}
                            value={item.apv_tender_ref_no ?? item.apvTenderRefNo ?? ""}
                            className="loapo-input"
                            disabled={isDisabled}
                            onChange={(e) => handleInputChange(e, item.P_grp_item_desc, "apv_tender_ref_no")}
                          />
                        </td>

                        {/* Kolom PO No. */}
                        <td className="cell-input text-center">
                          <input
                            type="text"
                            placeholder="PO No."
                            title={item.po_no ?? ""}
                            value={item.po_no ?? ""}
                            className="loapo-input"
                            disabled={isDisabled}
                            onChange={(e) => handleInputChange(e, item.P_grp_item_desc, "po_no")}
                          />
                        </td>

                        {/* Interim PO Amount */}
                        <td className="cell-amount text-right">
                          {item.P_grp_item_desc?.toLowerCase().includes("consultant fees") ||
                            item.P_grp_item_desc?.toLowerCase().includes("qs fees") ? (
                            <span className="amount-readonly font-mono">
                              ${formatNumber(item.finalValue === 0 ? item.totalValue : item.finalValue)}
                            </span>
                          ) : (
                            <input
                              type="text"
                              placeholder="0.00"
                              value={
                                editValues[item.P_grp_item_desc + "_interim"] ??
                                (item.interim_po_amount_wo_gst == null || item.interim_po_amount_wo_gst === 0
                                  ? ""
                                  : formatNumber(item.interim_po_amount_wo_gst))
                              }
                              className="loapo-input text-right font-mono"
                              onChange={(e) => {
                                const key = item.P_grp_item_desc + "_interim";
                                setEditValues(prev => ({ ...prev, [key]: e.target.value }));
                              }}
                              onBlur={(e) => {
                                const key = item.P_grp_item_desc + "_interim";
                                const rawValue = e.target.value.replace(/,/g, "");
                                handleInputChange({ target: { value: rawValue } }, item.P_grp_item_desc, "interim_po_amount_wo_gst");
                                setEditValues(prev => {
                                  const copy = { ...prev };
                                  delete copy[key];
                                  return copy;
                                });
                              }}
                            />
                          )}
                        </td>

                        {/* Final PO Amount */}
                        <td className="cell-amount text-right" style={{ paddingRight: "16px" }}>
                          <input
                            type="text"
                            placeholder="0.00"
                            value={
                              editValues[item.P_grp_item_desc + "_final"] ??
                              (item.final_po_amount_wo_gst == null || item.final_po_amount_wo_gst === 0
                                ? ""
                                : formatNumber(item.final_po_amount_wo_gst))
                            }
                            className="loapo-input text-right font-mono"
                            style={{ width: "100%", minWidth: "140px", boxSizing: "border-box" }}
                            onChange={(e) => {
                              const key = item.P_grp_item_desc + "_final";
                              setEditValues(prev => ({ ...prev, [key]: e.target.value }));
                            }}
                            onBlur={(e) => {
                              const key = item.P_grp_item_desc + "_final";
                              const rawValue = e.target.value.replace(/,/g, "");
                              handleInputChange({ target: { value: rawValue } }, item.P_grp_item_desc, "final_po_amount_wo_gst");
                              setEditValues(prev => {
                                const copy = { ...prev };
                                delete copy[key];
                                return copy;
                              });
                            }}
                          />
                        </td>
                      </tr>
                    ))
                ) : (
                  <tr>
                    <td colSpan="8" style={{ textAlign: "center", padding: "32px", color: "#64748b" }}>
                      {dataLoading ? "Loading data..." : "No records found"}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Loapoiframe;
